import Card from 'components/Layout/Card'
import PageHeader from 'components/Layout/PageHeader'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import './Bundle.scss'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import TsxUtils from '../../utils/tsx'
import FillingSpinner, { FillingSpinnerType } from '../../components/FillingSpinner'
import BundlesTable from './components/BundlesTable/BundlesTable'
import debounce from 'lodash/debounce'
import BundlesService from './services/bundles.service'
import { bundleActions } from './store/bundle-slice'
import { BundleModel } from '../../api/bundle/models/bundle.model'
import BundleDetailsModal from './containers/BundleDetailsModal/BundleDetailsModal'
import BundleFilters from './containers/BundlesFilters/BundleFilters'

const Bundle: React.FC = () => {
  const debounceTime = 2000
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { loading, pageNumber, totalItemsCount, filters, data } = useSelector(
    (state: RootState) => state.bundles
  )
  const debouncedFetchBundles = useCallback(debounce(BundlesService.fetchBundles, debounceTime), [])

  useEffect(() => {
    const firstPage = 1

    void debouncedFetchBundles(filters, firstPage)
  }, [filters])

  useEffect(() => {
    // Reset state on unmount/destroy
    return () => {
      dispatch(bundleActions.resetState())
    }
  }, [])

  const setPageNumber = (page: number) => {
    void BundlesService.fetchBundles(filters, page)
  }

  const onRowClick = (bundle?: BundleModel) => {
    if (!bundle) {
      return
    }

    void BundlesService.fetchBundle(bundle.id)
  }

  return (
    <div className={'Bundle__container'}>
      <PageHeader>{t('bundle.title')}</PageHeader>

      <BundleFilters />

      <Card className={TsxUtils.extraStyle(loading, 'Bundle--loading')}>
        {loading ? (
          <FillingSpinner type={FillingSpinnerType.STANDARD} />
        ) : (
          <BundlesTable
            pageNumber={pageNumber}
            totalItemsCount={totalItemsCount}
            data={data}
            rowClick={onRowClick}
            setPageNumber={setPageNumber}
          />
        )}
        <BundleDetailsModal />
      </Card>
    </div>
  )
}

export default Bundle
